import { Stack, Typography } from "@mui/material";
import { useBoundStore } from "useStore";
import { useNavigate } from "react-router-dom";

export default function CampaignNameCell({ row }) {
  const setSelectedCampaign = useBoundStore(
    (state) => state.setSelectedCampaign,
  );

  const clearCmEditedRows = useBoundStore((state) => state.clearCmEditedRows);
  const navigate = useNavigate();

  const noAds = row.adCount === 0;

  const handleNavigateToAds = () => {
    clearCmEditedRows();
    setSelectedCampaign(row);
    navigate("/martech/campaign-manager/ads");
  };

  return (
    <Stack
      onClick={noAds ? () => {} : handleNavigateToAds}
      sx={{
        display: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        cursor: noAds ? "default" : "pointer",
        "&:hover .campaign-name": !noAds && { textDecoration: "underline" },
      }}
    >
      <Typography
        className="campaign-name"
        variant="body2"
        sx={{ color: "#002878", fontSize: "12px", fontWeight: 500 }}
      >
        {row.campaignName}
      </Typography>
      <Typography variant="body2" sx={{ color: "#00000099", fontSize: "11px" }}>
        {row.adCount} anuncios
      </Typography>
    </Stack>
  );
}
